import * as Braze from "@braze/web-sdk";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { HTTP_STATUS, useApiClient } from "../../api-client";
import { useMetrics } from "../../metrics";
import { ROUTES } from "../../routes";
import { useCompany } from "./useCompany";
import { useEmployee } from "./useEmployee";
import { useEmployment } from "./useEmployment";

type Step = {
  name: string;
};

const useProductSteps = (isAgreementsShowTicksAccordingly: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [productSteps, setProductSteps] = useState<Step[]>([]);
  const { get } = useApiClient();
  const navigate = useNavigate();
  const { employmentId } = useEmployment();
  const { employee } = useEmployee();
  const { company } = useCompany();
  const { identify } = useMetrics();

  const getEmployeeProductSteps = async () => {
    try {
      const { status, data } = await get(
        `/v1/employees/${employmentId}/product-steps`
      );
      if (status !== HTTP_STATUS.OK) {
        setIsLoading(false);
      }

      if (data) {
        setProductSteps(data.content);
      }

      setIsLoading(false);
    } catch (e) {
      navigate(ROUTES.PAGE_FAILED);
    }
  };

  useEffect(() => {
    if (isAgreementsShowTicksAccordingly) return;
    if (!employee || !company) return;
    identify(employee, company);
    Braze.changeUser(employee.id);
    Braze.automaticallyShowInAppMessages();
    Braze.openSession();
  }, [employee, company, isAgreementsShowTicksAccordingly]);

  useEffect(() => {
    if (isAgreementsShowTicksAccordingly) return;
    if (!employmentId) return;
    getEmployeeProductSteps();
  }, [employmentId, isAgreementsShowTicksAccordingly]);

  return {
    productSteps,
    isLoading,
  };
};

export { useProductSteps };
